import { render } from "./owner.vue?vue&type=template&id=88211a4e&scoped=true&ts=true"
import script from "./owner.vue?vue&type=script&lang=ts"
export * from "./owner.vue?vue&type=script&lang=ts"

import "./owner.vue?vue&type=style&index=0&id=88211a4e&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88211a4e"]])

export default __exports__